import socket from "./socketInstance";

export const socketEmit = (event, payload = {}, timeoutMs = 15000) => {
  return new Promise((resolve, reject) => {
    // Fail immediately if socket is not connected instead of hanging
    if (!socket.connected) {
      return reject(new Error("Socket is not connected"));
    }

    const timer = setTimeout(() => {
      reject(new Error(`Socket timeout: no response for '${event}' after ${timeoutMs}ms`));
    }, timeoutMs);

    socket.emit(event, JSON.stringify(payload), (response) => {
      clearTimeout(timer);
      try {
        const parsedResponse = JSON.parse(response);
        resolve(parsedResponse);
      } catch (error) {
        reject("Failed to parse response: " + error);
      }
    });
  });
};

export const socketOn = (event, callback) => {
  socket.on(event, (data) => {
    try {
      const parsedData = JSON.parse(data);
      callback(parsedData);
    } catch (error) {
      console.error(`Failed to parse data from '${event}':`, error);
    }
  });
};
